<script lang="ts">
  type Tone = 'brand' | 'success' | 'warning' | 'danger' | 'neutral' | 'verde' | 'amarillo' | 'rojo' | 'gris' | 'total' | 'muted';

  let {
    label,
    value,
    hint = '',
    tone = 'brand' as Tone,
  }: {
    label: string;
    value: string | number;
    hint?: string;
    tone?: Tone;
  } = $props();
</script>

<div class="kpi {tone}">
  <div class="kpi-glow"></div>
  <span class="lbl">{label}</span>
  <strong class="val">{value}</strong>
  {#if hint}<small>{hint}</small>{/if}
</div>

<style>
  .kpi {
    position: relative;
    padding: 1.05rem 1.15rem;
    border-radius: var(--radius-xl);
    border: 1px solid var(--glass-border);
    background: var(--glass-bg-card);
    backdrop-filter: var(--glass-blur);
    -webkit-backdrop-filter: var(--glass-blur);
    box-shadow: var(--glass-shadow);
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    min-height: 5.5rem;
    overflow: hidden;
    transition: box-shadow 0.3s ease, transform 0.3s ease, border-color 0.3s ease;
  }

  .kpi:hover {
    box-shadow: var(--glass-shadow-lg);
    transform: translateY(-2px);
    border-color: var(--glass-border-strong);
  }

  .kpi-glow {
    position: absolute;
    top: -20px;
    right: -20px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }

  .kpi:hover .kpi-glow { opacity: 0.5; }

  .brand .kpi-glow { background: radial-gradient(circle, rgba(139,92,246,0.25) 0%, transparent 70%); }
  .success .kpi-glow, .verde .kpi-glow { background: radial-gradient(circle, rgba(16,185,129,0.2) 0%, transparent 70%); }
  .warning .kpi-glow, .amarillo .kpi-glow { background: radial-gradient(circle, rgba(245,158,11,0.2) 0%, transparent 70%); }
  .danger .kpi-glow, .rojo .kpi-glow { background: radial-gradient(circle, rgba(239,68,68,0.2) 0%, transparent 70%); }
  .total .kpi-glow { background: radial-gradient(circle, rgba(255,255,255,0.3) 0%, transparent 70%); }

  .lbl {
    font-size: 0.72rem;
    color: var(--text-secondary);
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    position: relative;
    z-index: 1;
  }

  .val {
    font-size: 1.85rem;
    line-height: 1.1;
    color: var(--text-primary);
    font-weight: 800;
    letter-spacing: -0.02em;
    position: relative;
    z-index: 1;
  }

  small {
    font-size: 0.72rem;
    color: var(--text-secondary);
    position: relative;
    z-index: 1;
  }

  .brand .val { color: #7c3aed; }
  .success .val, .verde .val { color: #059669; }
  .warning .val, .amarillo .val { color: #b45309; }
  .danger .val, .rojo .val { color: #dc2626; }

  .success, .verde { border-color: rgba(16,185,129,0.2); }
  .warning, .amarillo { border-color: rgba(245,158,11,0.2); }
  .danger, .rojo { border-color: rgba(239,68,68,0.2); }

  .total {
    background: linear-gradient(135deg, #5b21b6, #7c3aed, #8b5cf6);
    border: 0;
    box-shadow: 0 8px 24px rgba(124,58,237,0.3);
  }
  .total .lbl, .total .val, .total small { color: #fff; }

  .gris .val { color: var(--text-secondary); }
  .neutral .val { color: var(--text-primary); }

  .muted {
    opacity: 0.55;
    border-style: dashed;
  }
  .muted .val { color: var(--text-secondary); font-size: 1.35rem; }
</style>
